import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { BehaviorSubject, map, Observable, take, tap } from 'rxjs';

/** Errors in {controlKey: errorMessage} format */
export type BeValidatorErrors = Record<string, string>;
export type BeValidatorErrorsSubject = BehaviorSubject<Record<string, string>>;

/** BE error identifier. Form control will have this in its errors */
export const beErrorKeyName = 'invalidBE';

/**
 * Manage errors from errors$ subject
 * @param controlKey control key identifier
 */
export const beValidator = (controlKey: string, errors$: BeValidatorErrorsSubject): AsyncValidatorFn => {
  let canShowError = false;
  let prevValue = '';
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    return errors$.pipe(
      take(1),
      tap((errors) => {
        if (errors[controlKey] && prevValue === control.value) {
          canShowError = true;
          return;
        }

        // Invalidate error and delete it so it wont be shown until next BE call
        if (errors[controlKey] && prevValue !== control.value) {
          canShowError = false;
          const errorsWithoutThisOne = errors;
          delete errorsWithoutThisOne[controlKey];
          errors$.next(errorsWithoutThisOne);
          return;
        }
      }),
      map((errors) => {
        prevValue = control.value;
        if (errors[controlKey] && canShowError) {
          return {
            [beErrorKeyName]: true,
          };
        }
        return null;
      })
    );
  };
};
